import { render, staticRenderFns } from "./customerAnalysis.vue?vue&type=template&id=c70b7f7a&scoped=true"
import script from "./customerAnalysis.vue?vue&type=script&lang=js"
export * from "./customerAnalysis.vue?vue&type=script&lang=js"
import style0 from "./customerAnalysis.vue?vue&type=style&index=0&id=c70b7f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70b7f7a",
  null
  
)

export default component.exports